/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {BlackboxExporter} from "../model/blackbox-exporter";
/**
 * Controller for managing Blackbox Exporter configurations.
 */ 

@Injectable({
    providedIn: "root",
})
export class SimBlackboxExporterConfigurationService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Deletes a Grafana report configuration.
 */ 

    public deleteBlackboxExporterConfiguration(blackboxExporterId: string) {
        return super.post<void>(`/api/BlackboxExporterConfiguration/DeleteBlackboxExporterConfiguration/${encodeURIComponent(blackboxExporterId)}`, {});
    }
/**
 * Retrieves an GrafanaReportConfiguration object by its ID.
 */ 

    public getBlackboxConfigurationById(blackboxExporterId: string) {
        return super.get<BlackboxExporter>(`/api/BlackboxExporterConfiguration/GetBlackboxConfigurationById/${encodeURIComponent(blackboxExporterId)}`, );
    }
/**
 * Retrieves the list of Blackbox Exporter configurations.
 */ 

    public getBlackboxExporterConfigurations() {
        return super.get<BlackboxExporter[]>(`/api/BlackboxExporterConfiguration/GetBlackboxExporterConfigurations`, );
    }
/**
 * Inserts or updates a Blackbox Exporter configuration.
 */ 

    public upsertBlackboxExportConfiguration(blackboxExporter: BlackboxExporter) {
        return super.post<void>(`/api/BlackboxExporterConfiguration/UpsertBlackboxExportConfiguration`, blackboxExporter);
    }
}